<template>
    <el-card>
        <el-row class="rebind__title">账号换绑操作</el-row>
        
        <!-- 新用户rid -->
        <el-row class="rebind__input-section">
            <div class="input-group">
                <span class="input-label">新用户rid：</span>
                <el-input 
                    v-model="newUserRid" 
                    style="width: 200px" 
                    placeholder="请输入新用户rid"
                    @input="onNewUserRidInput"
                    :disabled="loading"
                ></el-input>
            </div>
            
            <!-- 新用户信息展示 -->
            <div class="user-info" v-if="newUserInfo">
                <div class="user-avatar">
                    <img :src="newUserInfo.headIcon || '/default-avatar.png'" alt="头像" />
                </div>
                <div class="user-details">
                    <span>用户昵称：{{ newUserInfo.username }}</span>
                    <span v-if="newUserInfo.loginType === 1">谷歌账号：{{ newUserInfo.email || '' }}</span>
                    <span v-if="newUserInfo.loginType === 2">facebook账号：{{ newUserInfo.email || '' }}</span>
                    <span v-if="newUserInfo.loginType === 3">电话号码账号：{{ newUserInfo.email || '' }}</span>
                    <span v-if="newUserInfo.loginType === 4">苹果账号：{{ newUserInfo.email || '' }}</span>
                </div>
            </div>
        </el-row>

        <!-- 原用户rid -->
        <el-row class="rebind__input-section">
            <div class="input-group">
                <span class="input-label">原用户rid：</span>
                <el-input 
                    v-model="oldUserRid" 
                    style="width: 200px" 
                    placeholder="请输入原用户rid"
                    @input="onOldUserRidInput"
                    :disabled="loading"
                ></el-input>
            </div>
            
            <!-- 原用户信息展示 -->
            <div class="user-info" v-if="oldUserInfo">
                <div class="user-avatar">
                    <img :src="oldUserInfo.headIcon || '/default-avatar.png'" alt="头像" />
                </div>
                <div class="user-details">
                    <span>用户昵称：{{ oldUserInfo.username }}</span>
                    <span v-if="oldUserInfo.loginType === 1">谷歌账号：{{ oldUserInfo.email || '' }}</span>
                    <span v-if="oldUserInfo.loginType === 2">facebook账号：{{ oldUserInfo.email || '' }}</span>
                    <span v-if="oldUserInfo.loginType === 3">电话号码账号：{{ oldUserInfo.email || '' }}</span>
                    <span v-if="oldUserInfo.loginType === 4">苹果账号：{{ oldUserInfo.email || '' }}</span>
                </div>
            </div>
        </el-row>

        <!-- 操作按钮 -->
        <el-row class="rebind__buttons">
            <el-button type="primary" @click="handleConfirm" :loading="loading">确认</el-button>
        </el-row>

        <!-- 账号换绑日志 -->
        <el-row class="rebind__log-section">
            <div class="log-title">账号换绑日志</div>
            <div class="log-search">
                <span>用户id：</span>
                <el-input 
                    v-model="searchRid" 
                    style="width: 200px" 
                    placeholder="请输入用户id"
                ></el-input>
                <el-button style="margin-left: 10px;" type="primary" @click="getLogList(1)">查询</el-button>
            </div>
            
            <!-- 日志表格 -->
            <el-table :data="logTableList" border>
                <el-table-column prop="fromRid" align="center" label="新用户rid"></el-table-column>
                <el-table-column prop="fromUsername" align="center" label="用户昵称"></el-table-column>
                <el-table-column prop="fromLoginType" align="center" label="绑定登录方式" :formatter="formatLoginType"></el-table-column>
                <el-table-column prop="fromEmail" align="center" label="绑定账号"></el-table-column>
                <el-table-column prop="ctime" align="center" label="换绑时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="toRid" align="center" label="原用户rid"></el-table-column>
                <el-table-column prop="toUsername" align="center" label="原用户昵称"></el-table-column>
                <el-table-column prop="toLoginType" align="center" label="原绑定登录方式" :formatter="formatLoginType"></el-table-column>
                <el-table-column prop="toEmail" align="center" label="原绑定账号"></el-table-column>
                <el-table-column prop="operator" align="center" label="操作人"></el-table-column>
            </el-table>
            
            <!-- 分页 -->
            <el-row>
                <el-pagination 
                    background 
                    layout="prev, pager, next" 
                    :total="logTotal" 
                    :page-size="logPageSize"
                    :current-page.sync="logCurrentPage" 
                    @current-change="logHandleCurrentChange">
                </el-pagination>
            </el-row>
        </el-row>

        <!-- 确认弹窗 -->
        <el-dialog
            title="Tips"
            :visible.sync="confirmDialogVisible"
            width="400px"
            :close-on-click-modal="false"
        >
            <div class="confirm-content">
                <i class="el-icon-warning" style="color: #E6A23C; margin-right: 10px;"></i>
                <span>Are you sure you want to confirm the changes?</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmRebind">确定</el-button>
            </span>
        </el-dialog>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            newUserRid: '',
            oldUserRid: '',
            newUserInfo: null,
            oldUserInfo: null,
            loading: false,
            confirmDialogVisible: false,
            
            // 防抖定时器
            newUserRidTimer: null,
            oldUserRidTimer: null,
            
            // 日志相关
            searchRid: '',
            logTableList: [],
            logTotal: 0,
            logCurrentPage: 1,
            logPageSize: 30,
        }
    },
    created() {
        this.getLogList()
    },
    beforeDestroy() {
        // 清除定时器
        if (this.newUserRidTimer) {
            clearTimeout(this.newUserRidTimer)
        }
        if (this.oldUserRidTimer) {
            clearTimeout(this.oldUserRidTimer)
        }
    },
    methods: {
        // 新用户rid输入处理（防抖）
        onNewUserRidInput() {
            // 清除之前的定时器
            if (this.newUserRidTimer) {
                clearTimeout(this.newUserRidTimer)
            }
            
            // 设置新的定时器
            this.newUserRidTimer = setTimeout(() => {
                this.checkNewUserRid()
            }, 500)
        },
        
        // 检查新用户rid
        async checkNewUserRid() {
            if (!this.newUserRid) {
                this.newUserInfo = null
                return
            }
            
            if (!this.validateRid(this.newUserRid)) {
                this.$message.error('rid格式不正确，只能填写数字且仅支持cde和AppStore_tikko渠道下的账号id')
                return
            }
            
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.account_rebind_check,
                    data: {
                        rid: parseInt(this.newUserRid)
                    },
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    this.newUserInfo = res.data
                } else {
                    this.$message.error(res.msg || res.message)
                    this.newUserInfo = null
                }
            } catch (error) {
                this.$message.error('查询用户信息失败')
                this.newUserInfo = null
            }
        },
        
        // 原用户rid输入处理（防抖）
        onOldUserRidInput() {
            // 清除之前的定时器
            if (this.oldUserRidTimer) {
                clearTimeout(this.oldUserRidTimer)
            }
            
            // 设置新的定时器
            this.oldUserRidTimer = setTimeout(() => {
                this.checkOldUserRid()
            }, 600)
        },
        
        // 检查原用户rid
        async checkOldUserRid() {
            if (!this.oldUserRid) {
                this.oldUserInfo = null
                return
            }
            
            if (!this.validateRid(this.oldUserRid)) {
                this.$message.error('rid格式不正确，只能填写数字且仅支持cde和AppStore_tikko渠道下的账号id')
                return
            }
            
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.account_rebind_check,
                    data: {
                        rid: parseInt(this.oldUserRid)
                    },
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    this.oldUserInfo = res.data
                } else {
                    this.$message.error(res.msg || res.message)
                    this.oldUserInfo = null
                }
            } catch (error) {
                this.$message.error('查询用户信息失败')
                this.oldUserInfo = null
            }
        },
        
        // 验证rid格式
        validateRid(rid) {
            return /^\d+$/.test(rid)
        },
        

        
        // 确认操作
        handleConfirm() {
            // 验证输入
            if (!this.newUserRid || !this.oldUserRid) {
                this.$message.error('用户id为空')
                return
            }
            
            if (this.newUserRid === this.oldUserRid) {
                this.$message.error('同一账号无法换绑')
                return
            }
            
            if (!this.newUserInfo || !this.oldUserInfo) {
                this.$message.error('请先输入正确的用户rid')
                return
            }
            
            // 显示确认弹窗
            this.confirmDialogVisible = true
        },
        
        // 确认换绑
        async confirmRebind() {
            this.loading = true
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.account_rebind_do,
                    data: {
                        fromRid: parseInt(this.oldUserRid),
                        toRid: parseInt(this.newUserRid),
                        operator: this.$store.getters.username
                    },
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    this.$message.success('替换成功')
                    this.handleCancel()
                    this.getLogList(1)
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                this.$message.error('操作失败')
            } finally {
                this.loading = false
                this.confirmDialogVisible = false
            }
        },
        
        // 取消操作
        handleCancel() {
            // 清除定时器
            if (this.newUserRidTimer) {
                clearTimeout(this.newUserRidTimer)
                this.newUserRidTimer = null
            }
            if (this.oldUserRidTimer) {
                clearTimeout(this.oldUserRidTimer)
                this.oldUserRidTimer = null
            }
            
            this.newUserRid = ''
            this.oldUserRid = ''
            this.newUserInfo = null
            this.oldUserInfo = null
        },
        
        // 获取日志列表
        async getLogList(page) {
            if (page) {
                this.logCurrentPage = page
            }
            
            try {
                const requestData = {
                    page: this.logCurrentPage
                }
                
                // 如果有搜索条件，添加toRid参数
                if (this.searchRid) {
                    requestData.toRid = parseInt(this.searchRid)
                }
                
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.account_rebind_list,
                    data: requestData,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    this.logTableList = res.data.data || []
                    this.logTotal = res.data.total || 0
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                this.$message.error('获取日志失败')
            }
        },
        
        // 日志分页
        logHandleCurrentChange(page) {
            this.getLogList(page)
        },
        
        // 格式化时间
        formatDate(row, column, cellValue) {
            if (!cellValue) return ''
            const date = new Date(cellValue * 1000)
            return date.getFullYear() + '-' + 
                   (date.getMonth() + 1).toString().padStart(2, '0') + '-' + 
                   date.getDate().toString().padStart(2, '0') + ' ' + 
                   date.getHours().toString().padStart(2, '0') + ':' + 
                   date.getMinutes().toString().padStart(2, '0') + ':' + 
                   date.getSeconds().toString().padStart(2, '0')
        },
        
        // 格式化登录类型
        formatLoginType(row, column, cellValue) {
            const typeMap = {
                1: '谷歌登录',
                2: 'facebook登录',
                3: '电话号码登录',
                4: '苹果登录',
            }
            return typeMap[cellValue] || cellValue
        }
    }
}
</script>

<style scoped lang="scss">
.rebind {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 30px;
    }
    
    &__input-section {
        margin-bottom: 30px;
        
        .input-group {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            
            .input-label {
                font-size: 16px;
                font-weight: 600;
                margin-right: 10px;
                min-width: 120px;
            }
        }
        
        .user-info {
            display: flex;
            align-items: center;
            margin-left: 130px;
            padding: 15px;
            background-color: #f5f5f5;
            border-radius: 8px;
            
            .user-avatar {
                margin-right: 20px;
                
                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }
            
            .user-details {
                display: flex;
                flex-direction: column;
                gap: 5px;
                
                span {
                    font-size: 14px;
                    color: #666;
                }
            }
        }
    }
    
    &__buttons {
        margin-bottom: 40px;
        margin-left: 130px;
        
        .el-button {
            margin-right: 10px;
        }
    }
    
    &__log-section {
        .log-title {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 20px;
        }
        
        .log-search {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            
            span {
                font-size: 16px;
                margin-right: 10px;
            }
        }
        
        .el-table {
            margin-bottom: 20px;
        }
    }
}

.confirm-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    font-size: 16px;
}

.dialog-footer {
    text-align: right;
}
</style>
